import PlainMarkdownText from '@basic/PlainMarkdownText';
import { DEFAULT_LANDING_PAGE_ACCENT_COLOR } from '@consts';
import ChevronDownIcon from '@icons/ChevronDownIcon';
import ChevronUpIcon from '@icons/ChevronUpIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useState } from 'react';
import { usePaymentAndOrder } from '../../payments/PaymentAndOrderContext';
import { parseHighlightedText } from './highlighters';
import { useLandingPageTranslation } from './useLandingPageTranslation';

export default function GoalLandingPageModulesSection() {
  const { state } = usePaymentAndOrder();

  const accentColor = state.goal?.landingPage?.accentColor || DEFAULT_LANDING_PAGE_ACCENT_COLOR;
  const modulesSection = state.goal?.landingPage?.modulesSection;
  const [expandedModule, setExpandedModule] = useState<number | null>(null);
  const { t } = useLandingPageTranslation();

  if (!state.goal?.landingPage?.modules) return <></>;

  const toggleModule = (moduleId: number) => {
    setExpandedModule(expandedModule === moduleId ? null : moduleId);
  };

  return (
    <div
      id='toc'
      className={classNames(
        'w-full max-w-[1200px] mx-auto flex flex-col gap-huge @[640px]:gap-[96px] items-center justify-center',
        // RESPONSIVE STYLES
        'p-sm @[768px]:p-md @[1280px]:py-xxxl @[1280px]:px-none'
      )}
    >
      <p
        className={classNames(
          'flex flex-col @[640px]:flex-row gap-md font-bold justify-center leading-[1.1] text-center w-full',
          // RESPONSIVE STYLES
          'text-[32px] @[480px]:text-[48px] @[640px]:text-[60px] break-words'
        )}
      >
        <span className={classNames(setupForDark('text-white'))}>
          {parseHighlightedText(
            modulesSection?.sectionTitle || t('domains.goals.landingPage.toc.sectionTitle'),
            'text-white',
            undefined,
            accentColor
          )}
        </span>
        {/* //FIXME: To jest do usuniecia w api modulesSection?.sectionLeader */}
        {/* <span style={{ color: accentColor }}>
          {modulesSection?.sectionLeader || t('domains.goals.landingPage.toc.sectionLeader')}
        </span> */}
      </p>

      <div className='flex flex-col gap-md @[640px]:gap-lg w-full'>
        {state.goal?.landingPage?.modules.map((module, moduleIndex) => {
          const isExpanded = expandedModule === moduleIndex;

          return (
            <button
              key={moduleIndex}
              onClick={() => toggleModule(moduleIndex)}
              className={`
                flex gap-xl items-start overflow-clip p-xl relative rounded-lg w-full
                transition-all duration-300
                border border-solid
                ${isExpanded ? '' : 'bg-landing-surface-card border-[#48484a]'}
              `}
              style={
                isExpanded
                  ? {
                      borderColor: accentColor,
                      background: `linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%), linear-gradient(90deg, ${accentColor} 0%, ${accentColor} 100%)`
                    }
                  : undefined
              }
            >
              <div className='flex flex-col gap-xl grow items-start justify-center min-h-px min-w-px'>
                <div className='flex flex-col gap-md w-full'>
                  {/* Module Title and Description */}
                  <div className={`flex flex-col gap-md w-full ${isExpanded ? '' : ''}`}>
                    <div
                      className={classNames(
                        'font-medium leading-[1.2] text-left first-letter:capitalize',
                        setupForDark('text-white'),
                        // RESPONSIVE STYLES
                        'text-[20px] @[640px]:text-[24px]'
                      )}
                    >
                      {parseHighlightedText(
                        module.title ?? '',
                        'text-white',
                        undefined,
                        accentColor
                      )}
                    </div>

                    {isExpanded && (
                      <div
                        className={classNames(
                          'font-normal leading-[1.4] text-left',
                          setupForDark('text-white'),
                          // RESPONSIVE STYLES
                          'text-[16px] @[640px]:text-[20px]'
                        )}
                      >
                        <PlainMarkdownText text={module.description} accentColor={accentColor} />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Chevron Button */}
              <div
                className={`
                  flex items-center justify-center rounded-lg shrink-0 w-[40px] h-[40px]
                  ${isExpanded ? '' : setupForDark('bg-white')}
                `}
                style={isExpanded ? { backgroundColor: accentColor } : undefined}
              >
                {isExpanded ? (
                  <ChevronUpIcon size={18} className={classNames(setupForDark('text-white'))} />
                ) : (
                  <ChevronDownIcon size={18} className={classNames(setupForDark('text-black'))} />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
